<ng-template #container>
  <swiper-slide>
    <ng-content></ng-content>
  </swiper-slide>
</ng-template>
